import { render, staticRenderFns } from "./file-versions-table.vue?vue&type=template&id=61497e3e&scoped=true"
import script from "./file-versions-table.vue?vue&type=script&lang=js"
export * from "./file-versions-table.vue?vue&type=script&lang=js"
import style0 from "./file-versions-table.vue?vue&type=style&index=0&id=61497e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61497e3e",
  null
  
)

export default component.exports